
import { Component, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TInvite, API_TInvite_Filter } from "@/models/cases_expert_invites";

const TIMEOUT = 500;

const TABLE_INITIAL_LIMIT = 20;
const TABLE_INITIAL_OFFSET = 0;
const TABLE_INITIAL_ORDER = "desc";
const TABLE_INITIAL_ORDER_BY = "case_id";
const TABLE_INITIAL_IS_USED = "false";

const ICONS = {
  search: "search",
};

type ParamsKeyObject = {
  [key: string]: any;
};

@Component({
  components: {
    ExpertInvitesTable: () => import("@/modules/Services/Components/Table/ExpertInvitesTable.vue"),
  },
})
export default class Companies extends Vue {
  loading = false;

  loadingFilters = false;

  loadingOptions = false;

  items: API_TInvite[] = [];

  filters: API_TInvite_Filter = {
    company_name: [],
    product_type: [],
    permission: [],
    role: [],
    is_used: [],
  };

  params: ParamsKeyObject = {
    limit: TABLE_INITIAL_LIMIT,
    offset: TABLE_INITIAL_OFFSET,
    order: TABLE_INITIAL_ORDER,
    order_by: TABLE_INITIAL_ORDER_BY,
    is_used: TABLE_INITIAL_IS_USED,
    search: "",
  };

  savedFilters = `?is_used=${TABLE_INITIAL_IS_USED}`;

  async mounted() {
    await this.fetchInvites({ params: this.params, isLimit: true });

    await this.fetchTableFilters();
  }

  async fetchInvites({ params, isLimit }: { params: ParamsKeyObject; isLimit: boolean }) {
    try {
      this.loading = true;

      const { data } = await this.axios.get<API_TInvite[]>(API_ROUTES.EXPERT_INVITES(params));

      if (!data?.length && !isLimit) return (this.items = []);

      const items = data;

      this.items = isLimit ? [...this.items, ...items] : data;
    } finally {
      this.loading = false;
    }
  }

  async fetchTableFilters() {
    try {
      this.loadingFilters = true;

      const { data } = await this.axios.get<API_TInvite_Filter>(API_ROUTES.EXPERT_INVITES_FILTERS);

      if (!data) return;

      this.filters = data;
    } finally {
      this.loadingFilters = false;
    }
  }

  query = "";

  get searchBarProps() {
    return {
      iconPrepend: ICONS.search,
      placeholder: this.$tc("searchbar.placeholder"),
    };
  }

  timer = null;

  searchItems() {
    this.fetchInvites({ params: this.params, isLimit: false });
  }

  @Watch("query")
  queryChanged(search: string) {
    if (search) this.params.search = encodeURIComponent(search);

    if (!search) this.params.search = "";

    clearTimeout(this.timer);

    this.timer = setTimeout(this.searchItems, TIMEOUT);
  }
}
